import { lotsServices } from "../../../../../api/lots";
import type { OnsideInvoiceContent } from "../../../../../api/onsideInvoices";

/** Результат поиска строки НС по скану этикетки партии. */
export type StockFinishedGoodsShipmentContentScanResult =
    | { type: "notFound" }
    | { type: "single"; contentCode: number }
    | { type: "ambiguous"; contentCodes: number[] };

/**
 * Ищет строку НС по отсканированному `SoNum` партии. \
 * Ожидаем ровно одну партию по `SoNum`, затем строку с `LotCode === lot.LotCode`.
 * @param barcode отсканированное значение (`SoNum`)
 * @param contents текущие строки НС
 */
export async function resolveStockFinishedGoodsShipmentContentScan(
    barcode: string,
    contents: OnsideInvoiceContent[],
): Promise<StockFinishedGoodsShipmentContentScanResult> {
    const soNum = barcode.trim();
    if (soNum === "") {
        return { type: "notFound" };
    }

    const lots = await lotsServices.load({ flt: { SoNum: soNum } });
    if (lots.length !== 1 || lots[0].LotCode === 0) {
        return { type: "notFound" };
    }

    const lotCode = lots[0].LotCode;
    const matches = contents.filter((content) => content.LotCode === lotCode);

    if (matches.length === 0) {
        return { type: "notFound" };
    }

    if (matches.length === 1) {
        return { type: "single", contentCode: matches[0].Code };
    }

    return { type: "ambiguous", contentCodes: matches.map((content) => content.Code) };
}
